export default __webpack_public_path__ + "static/nft2-7cfb6d1610c25d7aa9e43d10816b6022.png";